// src/theme/theme.js
// Single source of truth — extracted from the MediHire logo.
// Blue (#2E7CF6) → Purple (#8A3ED9) → Pink (#E8579B)

export const colors = {
  // --- Brand (Logo-extracted) ---
  blue:           "#2E7CF6",   // left runner — primary actions
  purple:         "#8A3ED9",   // middle runner — accent / hover mid
  pink:           "#E8579B",   // hospital building — accent end

  // Gradient string (reuse anywhere)
  gradientPrimary: "linear-gradient(135deg, #2E7CF6 0%, #8A3ED9 55%, #E8579B 100%)",
  gradientHover:   "linear-gradient(135deg, #1a60d4 0%, #7230c2 55%, #c93f82 100%)",
  gradientLight:   "linear-gradient(135deg, #e8f0fe 0%, #f3eaff 55%, #fde8f3 100%)",

  // --- Semantic (mapped from brand) ---
  primary:         "#2E7CF6",
  primaryHover:    "#1a60d4",
  primaryLight:    "#e8f0fe",

  secondary:       "#8A3ED9",
  secondaryHover:  "#7230c2",
  secondaryLight:  "#f3eaff",

  accent:          "#E8579B",
  accentHover:     "#c93f82",
  accentLight:     "#fde8f3",

  // --- Feedback ---
  success:         "#52c41a",
  successBg:       "#f6ffed",
  warning:         "#faad14",
  warningBg:       "#fffbe6",
  error:           "#ff4d4f",
  errorBg:         "#fff2f0",
  info:            "#2E7CF6",

  // --- Neutrals ---
  textPrimary:     "#1a1a2e",
  textSecondary:   "#555555",
  textMuted:       "#888888",
  textDisabled:    "#bfbfbf",
  textOnGradient:  "#ffffff",

  borderDefault:   "#d9d9d9",
  borderLight:     "#f0f0f0",

  bgPage:          "#f5f7fa",
  bgCard:          "#ffffff",
  bgHeaderStrip:   "#ffffff",
};

// Industry-standard type scale (4px grid baseline)
export const typography = {
  fontFamily: '"Roboto", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',

  size: {
    xs:   "11px",   // captions, badges, helper text
    sm:   "12px",   // labels, secondary info
    base: "14px",   // Ant Design baseline, table cells
    md:   "16px",   // body paragraphs, form inputs
    lg:   "18px",   // card titles, sub-section labels
    xl:   "20px",   // section headings (h5/h4)
    "2xl":"24px",   // page sub-titles  (h3)
    "3xl":"28px",   // page titles      (h2)
    "4xl":"32px",   // hero headings    (h1)
  },

  weight: {
    light:    300,
    regular:  400,
    medium:   500,
    semibold: 600,
    bold:     700,
  },

  lineHeight: {
    tight:   "1.25",
    base:    "1.5",
    relaxed: "1.75",
  },
};

// Ant Design 5 token map — consumed by <ConfigProvider theme={{ token }}>
export const antdThemeToken = {
  // Brand colors
  colorPrimary:          colors.blue,
  colorSuccess:          colors.success,
  colorWarning:          colors.warning,
  colorError:            colors.error,
  colorInfo:             colors.info,
  colorLink:             colors.blue,
  colorLinkHover:        colors.purple,

  // Typography
  fontFamily:            typography.fontFamily,
  fontSize:              14,
  fontSizeSM:            12,
  fontSizeLG:            16,
  fontSizeXL:            20,
  fontSizeHeading1:      32,
  fontSizeHeading2:      28,
  fontSizeHeading3:      24,
  fontSizeHeading4:      20,
  fontSizeHeading5:      18,

  // Shape
  borderRadius:          6,
  borderRadiusLG:        8,
  borderRadiusSM:        4,
  lineHeight:            1.5,
  lineHeightLG:          1.75,

  // Backgrounds & text
  colorTextBase:         colors.textPrimary,
  colorTextSecondary:    colors.textSecondary,
  colorBorder:           colors.borderDefault,
  colorBorderSecondary:  colors.borderLight,
  colorBgLayout:         colors.bgPage,
  colorBgContainer:      colors.bgCard,

  // Spacing
  paddingContentVertical:   8,
  paddingContentHorizontal: 16,
};
